'use strict';

define('features/ctas/www',[
  'zipTools',
  'cookies',
  'storageUtil',
  'lib/util/zip'
], function (
  zipTools,
  cookies,
  su,
  zip
) {
  // TODO: while this is better than lib/tda/www.js, it's still pretty crummy
  return function wwwClickEvent(target) {
    var $target = $(target);
    var redirect = $target.attr('href');

    $target.on('click', function (e) {
      e.preventDefault();
      cookies.removeItem('geoIgnore', '/', cookies.getCrossDomainCookieDomain());
      window.zipTools.redirectPath = redirect;
      // Already confirmed zip is unlikely, but possible. User hit back button for example
      if (su.isConfirmedZip()) {
        zipTools.setInitialZipAndTransfer(zip.getCookiedDefaultFallback());
      } else {
        zipTools.detectZip();
      }
    });
  };
});

